import { FilterOptionKeys, GoalFilterDocument, GoalType } from '@griply/types';

// With no Type filter selected the surface shows everything — goals and
// projects — like every other filter.
export const getFilterDocumentGoalTypes = (
  filterDocument: GoalFilterDocument | null | undefined,
): GoalType[] => {
  const include = filterDocument?.filters?.[FilterOptionKeys.GoalType]?.include;
  return include?.length ? include : [GoalType.Goal, GoalType.Project];
};
